import type { infra } from '@photo-vault/shared';
import { awsAuthDriver } from './auth.js';
import { awsMetadataStore } from './metadata.js';
import { awsStorageDriver } from './storage.js';

export const awsInfraProvider: infra.InfraProvider = {
  mode: 'aws',
  auth: awsAuthDriver,
  metadata: awsMetadataStore,
  storage: awsStorageDriver,
};
